import { render, staticRenderFns } from "./OnboardingCentralPrimaryBanner.vue?vue&type=template&id=8ba4d3fe&scoped=true"
import script from "./OnboardingCentralPrimaryBanner.vue?vue&type=script&lang=js"
export * from "./OnboardingCentralPrimaryBanner.vue?vue&type=script&lang=js"
import style0 from "./OnboardingCentralPrimaryBanner.vue?vue&type=style&index=0&id=8ba4d3fe&prod&lang=sass&scoped=true"
import style1 from "./OnboardingCentralPrimaryBanner.vue?vue&type=style&index=1&id=8ba4d3fe&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ba4d3fe",
  null
  
)

export default component.exports